import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const MumbaiAddresses = {
    TOKEN_RING: "0xbBD91aD844557ADCbb97296216b3B3c977FCC4F2",
    TOKEN_KTON: "0xED1d1d219f85Bc634f250db5e77E0330Cddc9b2a",
    TOKEN_WETH: "0x3277B7BABbeadF5dC43D5350df25310f3c819965",
    ELEMENT_GOLD: "0xee4f69fc69F2C203a0572e43375f68a6e9027998",
    ELEMENT_WOOD: "0x3553b673A47E66482b6eCFAE5bfc090Cc7eeEd27",
    ELEMENT_WATER: "0xfA91cA10745A80CcFD83Ad29Aa33Fdc5E8Ba582E",
    ELEMENT_FIRE: "0xe9e0e23fB22865b20599Ad4f2552D7F0824212d8",
    ELEMENT_SOIL: "0x3Af4364015Bbb02d0061E819C4a8989550356EAF",
    GOLD_RUSH_RAFFLE: "0x364Afad290Beeb005E75A5caD10bcc59C1Af3FA6",
    PVETEAM_PROXY: "0x09f89988390AB272a3E102d028c7904eB7643004",
    MATERIAL_PROXY: "0xF0A8be32CcD16c77046Ff5eB76ae49F21Dd95617",
    MATERIALTAKEBACK_PROXY: "0x8098D7E7bb049Ac1853D6DcCbc2538e646080834",
    CRAFTBASE_PROXY: "0x366694a6Af1C3aBe3AFedC24771BF3DdB0f9292E",
    LAND_CLOCK_AUCTION: "0x2CcB8D3c4e13369d509068A8839dcE3fF1CB6E4a",
    APOSTLE_CLOCK_AUCTION: "0x71d18878F49d3a40f605baBbD81c24045fcB524a",
    SIRING_CLOCK_AUCTION: "0x377F8d7649E89ed5E75013afB317E90F52542Df5",
    APOSTLE_BASE: "0x6c74a72444048A8588dEBeb749Ee60DB842aD90f",
    LAND_RESOURCE: "0xE233a0E201219f792B878517e840903B8d62B9d3",
    TOKEN_USE: "0x12DFfF6EB30A7A8BC95083f9b26AD332DC722d70",
    OBJECTOWNERSHIP: "0x7cD44a3C9696185BAC374F0Cd3018F4b24986cb0",
    SETTINGSREGISTRY: "0x25D12af5F912058425Fe4Ab7BA2A28469C493680",
    POINTS_REWARD_POOL: "0xf39Ba9a9f63A789A60a8d7d401c7d1c4616d8340",
    TOKEN_USER_POINTS: "0xE04c799682F9509CF3D23A15F4A8ddc32648EDd4",
    FURNACE_TREASURE: "0x1559Bf123D300f244ABdA95aefDA14F54C37B9B6",
    FURNACE_ITEM_BASE: "0xFd9160602c3805cbB271D56310dAb283728A8bC3",
    FURNACE_TAKEBACK: "0x20c3b4a6Cb3319d14ffB0C2d4C7b035f16C4B7D3",
    UNISWAP_EXCHANGE: "0xC17694286E463F1D679c89977326Eb8Ee32f8FAF",
    STAKINGREWARDSFACTORY: "0x701A77F6420148a94572a7863c27C456F18df284",
    GOLDRAFFLEPOOL_PROXY: "0x0581cb634420794f4CC0dAcEBda0365fC14e0FD0",
    WOODRAFFLEPOOL_PROXY: "0x7328014b704686cFC228BD6348b36e27cEecf2C8",
    WATERRAFFLEPOOL_PROXY: "0x29d72Ea1004114bC43C1DC75e13FDD280125d2a5",
    FIRERAFFLEPOOL_PROXY: "0xEedEC732BD29A5dCEaC2A02A60B097B12051d4b3",
    SOILRAFFLEPOOL_PROXY: "0x122D25B7383B053be1B69D0d7a2b75ADeBC16125",
};
export const MumbaiTokens = {
    RING: new Token(ChainId.MUMBAI, MumbaiAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.MUMBAI, MumbaiAddresses.TOKEN_KTON, 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.MUMBAI, MumbaiAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.MUMBAI, MumbaiAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.MUMBAI, MumbaiAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.MUMBAI, MumbaiAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.MUMBAI, MumbaiAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.MUMBAI],
};
